export interface ILicenseInfoResponse {
  state_license_id: string;
  contact_license_id: string;
}

export interface ILicenseInfoData {
  stateLicenseId: string;
  contactLicenseId: string;
}

export const convertILicenseInfoResponseToILicenseInfoData = ({
  state_license_id,
  contact_license_id,
}: ILicenseInfoResponse): ILicenseInfoData => ({
  contactLicenseId: contact_license_id,
  stateLicenseId: state_license_id,
});

export const convertILicenseInfoDataToILicenseInfoResponse = ({
  stateLicenseId,
  contactLicenseId,
}: ILicenseInfoData): ILicenseInfoResponse => ({
  state_license_id: stateLicenseId,
  contact_license_id: contactLicenseId,
});
